import type { BulkUpdateOvertimePoolsMutationVariables } from 'generated/resources/graphql'
import { BulkUpdateOvertimePoolsDocument } from 'generated/resources/graphql'

import { useMutation } from 'modules/core/hooks/useMutation'

type AttendanceMutationsBulkUpdateAttendanceOvertimePoolArgs =
  BulkUpdateOvertimePoolsMutationVariables

export const useBulkUpdateOvertimePools = () => {
  const [bulkUpdatePool, { loading }] = useMutation(BulkUpdateOvertimePoolsDocument, {
    extractorFn: (data) => data.attendanceMutations.bulkUpdateAttendanceOvertimePool,
  })

  const bulkUpdateOvertimePool = (
    variables: AttendanceMutationsBulkUpdateAttendanceOvertimePoolArgs
  ) => {
    return bulkUpdatePool({
      variables,
    })
  }

  return {
    loading,
    bulkUpdateOvertimePool,
  }
}
